import React, { useEffect, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import CheckIcon from "assets/svgIcons/CheckIcon";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import { useTranslation } from "react-i18next";
import {
  CenteredLoader,
  StyledCheckbox,
} from "commonComponents/FormElement/Checkbox/CheckboxStyled";
import { CircleBtn } from "assets/css/globle";
import {
  isUserAdmin,
  isUserBasic,
  isUserReadOnly,
  isUserSupport,
  userRoles
} from "../../../constant";
import DeleteIcon from "assets/svgIcons/DeleteIcon";
import AddIcon from "assets/svgIcons/AddIcon";
import EditIcon from "assets/svgIcons/EditIcon";
import ZoomIcon from "assets/svgIcons/ZoomIcon";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { PopUpContainer } from "assets/css/globle";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import {
  addImageApiCall,
  getAdImageApiCall,
} from "redux/reduxToolkitServices/_commonApiCalls/api";
import { UploadBtnWrapper } from "assets/css/globle";
import {
  Container,
  Header,
  BodySection,
  BodyHeader,
  MainSection,
  AddNewImageWrapper,
  PreviewImageWrapper,
} from "pages/Ads/ImageGallery/ImageGalleryStyled";
import { useDispatch, useSelector } from "react-redux";
import {
  COMMON_SERVICES,
  headersConfigData,
  headersConfigDatafile,
} from "redux/reduxToolkitServices/_commonServices/commonServices";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import _ from "lodash";
import { Loader } from "commonComponents/Loader/Loader";
import moment from "moment";
import { API_STATUSES } from "redux/_helpers/statuses";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";

export function sortAndFilter(type, arr) {
  if (type === "desc") {
    return arr?.sort((a, b) => {
      return a.description.localeCompare(b.description, "en-US", {
        sensitivity: "base",
      });
    });
  } else if (type === "file") {
    return arr?.sort((a, b) => {
      return a.filename.localeCompare(b.filename, "en-US", {
        sensitivity: "base",
      });
    });
  } else if (type === "date") {
    return arr?.sort((a, b) => {
      return verboseToDate(b?.uploadedUtc) - verboseToDate(a?.uploadedUtc);
    });
  } else {
    return arr?.sort((a, b) => {
      return a?.size - b?.size;
    });
  }
}

export function verboseToDate(vd) {
  if (vd?.year === undefined) {
    return;
  } else {
    return new Date(
      Date.UTC(vd.year, vd.month - 1, vd.day, vd.hour, vd.minute, vd.second)
    );
  }
}

const ImageGallery = () => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    getImageGalleryData,
    getImageGalleryStatus,
    putImageDescData,
    siteSettingDataReduxStateStatus,
    getUserRole,   
  } = useSelector((state) => state.commonReducers);
  const { getPrivilegeAction } = useSelector((state) => state?.commonReducers) || [];
  const { getAdImageData, getAdInsertImageData } = useSelector((state) => state.commonReducers) || [];

  const [checkedList] = useState([]);
  const [isAllInsertImages, setIsAllInsertImages] = useState(false);
  const [selectedInsertImages, setSelectedInsertImages] = useState([]);
  const [isAllSelectedGallary, setIsAllSelectedGallary] = useState(false);
  const [isSelectedInsertGallary, setSelectedInsertGallary] = useState([]);
  const [alertTxt, setAlertTxt] = useState("");
  const [alertModal, setAlertModal] = useState(false);
  const privilege = "SharedImages";
  const [addNewImage, setAddNewImage] = useState(false);
  const [bothImages, setBothImages] = useState(true);
  const [fullImages, setFullImages] = useState(false);
  const [insertImages, setInsertImages] = useState(false);
  const [sharedImages, setSharedImages] = useState(true);
  const [sharedImage, setSharedImage] = useState(false);
  const [allowedWidth] = useState([1280,1024,314]);
  const [allowedHeight] = useState([141,600,800,220]);
  const [localImages, setLocalImages] = React.useState(
    JSON.parse(localStorage.getItem("local-images")) || false
  );
  const [openPreviewImage, setPreviewImageOpen] = React.useState(false);
  const [dropDownValue, setDropDownValue] = useState("date");
  const [fullImagesArray, setFullImagesArray] = useState([]);
  const [insertClonedArray, setInsertClonedArray] = useState([]);
  const [zoomImageState, setZoomImageState] = useState("");
  const [openUpload, setOpenUpload] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [openSharedDelete, setSharedOpenDelete] = React.useState(false);
  const [activeButton, setActiveButton] = useState(false);
  const [deleteDisable, setDeleteDisable] = useState(true);  
  const [deleteSharedColor, setDeleteSharedColor] = useState(false);  
  const [selectedFile, setSelectedFile] = useState();
  const [pic] = useState();
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);
  const [disableUpload, setDisableUpload] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [openUploadError, setOpenUploadError] = useState(false);
  const [imagesData, setImagesData] = useState({ payload1: "", payload2: "", payload3: "", payload4: "" });
  const reader = new FileReader();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "600px",
    width: "100%",
    bgcolor: "background.paper",
    borderRadius: "5px",
    overflow: "hidden",
  };

  const overlayStyle = {
    position: "absolute",
    left: "0",
    top: "0",
    zIndex: "2",
  };

  useEffect(() => {
    setAddNewImage(false);
    dispatch(COMMON_SERVICES.getImageGalleryServices(siteId.get()));
  }, [siteId.get()]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getImageGalleryServices(siteId.get()));
  }, [putImageDescData]);

  useEffect(() => {
    let images = [];

    getImageGalleryData &&
      Array.isArray(getImageGalleryData) &&
      getImageGalleryData?.map(async (item) => {
        const { id } = item;
        let response = await getAdImageApiCall(id, headersConfigData);
        let imageBlob = await response.blob();
        let reader = new FileReader();
        reader.readAsDataURL(imageBlob);

        reader.onloadend = () => {
          let base64data = reader.result;
          images = [...images, { base64data, ...item }];
          setFullImagesArray(images);
        };
      });
  }, [getImageGalleryData, putImageDescData]);

  useEffect(() => {
    let images = [];
    getImageGalleryData &&
      Array.isArray(getImageGalleryData) &&
      getImageGalleryData?.map(async (item) => {
        if (item?.fullPage === false) {
          const { id } = item;
          let response = await getAdImageApiCall(id, headersConfigData);
          let imageBlob = await response.blob();
          let reader = new FileReader();
          reader.readAsDataURL(imageBlob);

          reader.onloadend = () => {
            let base64data = reader.result;
            images = [...images, { base64data, ...item }];
            setInsertClonedArray(images);
          };
        }
      });
  }, [getImageGalleryData, putImageDescData]);

  useEffect(() => {
    if(getAdImageData)
      setFullImagesArray(JSON.parse(JSON.stringify(getAdImageData)));
  }, [getAdImageData]);

  useEffect(() => {
    if(getAdInsertImageData)
      setInsertClonedArray(JSON.parse(JSON.stringify(getAdInsertImageData)));
  }, [getAdInsertImageData]);

  useEffect(() => {
    if (!localImages) {
      setIsAllSelectedGallary(false);
      setSelectedInsertGallary([]);
      setIsAllInsertImages(false);
      setSelectedInsertImages([]);
    }
  }, [localImages]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getPrivilegeServices(privilege));
  }, []);

  useEffect(() => {
    if (!fullImages && !bothImages) {
      setIsAllInsertImages(false);
      setSelectedInsertImages([]);
    }
  }, [fullImages]);

  useEffect(() => {
    if (!insertImages && !bothImages) {
      setIsAllSelectedGallary(false);
      setSelectedInsertGallary([]);
    }
  }, [insertImages]);

  useEffect(()=>{
    var fullGallery = fullImagesArray.concat(insertClonedArray);
    var selectedGallery = isSelectedInsertGallary.concat(selectedInsertImages);
    var item = fullGallery.filter((f)=> selectedGallery.includes(f.id) && f.shared==true);
    
    if(item && item.length>0 && sharedImages)
    {
      if((isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role)) && getPrivilegeAction)
      {
      setDeleteSharedColor(true);
      setDeleteDisable(false);
      }
      else
      {
      setDeleteSharedColor(false);
      setDeleteDisable(true);
      }
    }
    else if(selectedGallery.length>0)
    {
      setDeleteSharedColor(false);
      setDeleteDisable(false);
    }
    else
    setDeleteDisable(true);

  },[isSelectedInsertGallary,selectedInsertImages,localImages,sharedImages]);

  const handleOpenUpload = () => {
    setOpenUpload(true);
    setSharedImage(false);
  }

  const handleDeleteOpen = () => {
    if (
      selectedInsertImages.length > 0 ||
      isSelectedInsertGallary.length > 0 ||
      isAllSelectedGallary ||
      isAllInsertImages
    ) {
      let sharedImageFound = [];
      fullImagesArray.filter((v) => {
        if ((isSelectedInsertGallary.includes(v.id) || selectedInsertImages.includes(v.id)) && v.shared) {
          return sharedImageFound.push(v.id);
        }
      });
      if(sharedImageFound.length>0) setSharedOpenDelete(true);
      else setSharedOpenDelete(false);
      setOpenDelete(true);
    }
  }

  const localImageChange = () => {
    handleSelectAllItems(isAllSelectedGallary,isAllInsertImages,sharedImages, !localImages );
    localStorage.setItem("local-images", JSON.stringify(!localImages));
    setLocalImages(!localImages);
    setAddNewImage(false);
  }

  const sharedImageChange = () => {
    handleSelectAllItems(isAllSelectedGallary,isAllInsertImages, !sharedImages, localImages);
    setSharedImages(!sharedImages);
    setAddNewImage(false);
  } 
  
  const handleSelectAllItems = (fullpage,insert,sharedImages,localImages) => {
    if(fullpage){
      let temp = {};
      temp = fullImagesArray.filter((data) =>{return data.fullPage});
      if(sharedImages && localImages)
      {
        temp = temp.map((data) => data.id);
      }
      else if(sharedImages && !localImages)
      {
      temp = temp.filter((data) => data.shared).map((data)=> data.id);
      }
      else if(!sharedImages && localImages)
      {
      temp = temp.filter((data) => !data.shared).map((data)=> data.id);
      }
      setSelectedInsertGallary(temp);
    }
    if(insert)
      {
        let temp = {};
        if(sharedImages && localImages)
        {
          temp = insertClonedArray.map((data) => data.id);
        }
        else if(sharedImages && !localImages)
        {
        temp = insertClonedArray.filter((data) => data.shared).map((data)=> data.id);
        }
        else if(!sharedImages && localImages)
        {
        temp = insertClonedArray.filter((data) => !data.shared).map((data)=> data.id);
        }
        setSelectedInsertImages(temp);
      }
  }

  const handleCheckboxClick = (id, from, cb) => {
    let unselctedItems = [];
    if (from === "insertImage") {
      unselctedItems = [...selectedInsertImages];
    }
    if (from === "imageGallary") {
      unselctedItems = [...isSelectedInsertGallary];
    }
    const index = unselctedItems.indexOf(id);
    unselctedItems.includes(id)
      ? unselctedItems.splice(index, 1)
      : unselctedItems.push(id);

    if (from === "imageGallary") {
      unselctedItems.length < fullImagesArray.length
        ? setIsAllSelectedGallary(false)
        : setIsAllSelectedGallary(true);
    }

    if (from === "insertImage") {
      unselctedItems.length < insertClonedArray.length
        ? setIsAllInsertImages(false)
        : setIsAllInsertImages(true);
    }
    cb(unselctedItems);
  }

  const selectItem = (e, from) => {
    if (from === "imageGallary") {
      if (e.target.checked) {
        setIsAllSelectedGallary(true);
        handleSelectAllItems(true,false,sharedImages,localImages);
      } 
      else {
        setIsAllSelectedGallary(false);
        setSelectedInsertGallary([]);
      }
    }
    if (from === "insertImage") {
      if (e.target.checked) {
        setIsAllInsertImages(true);
        handleSelectAllItems(false,true,sharedImages,localImages);
      } 
      else {
        setIsAllInsertImages(false);
        setSelectedInsertImages([]);
      }
    }
    
  }

  const deleteImages = () => {
    const IdsOne = [];    
    fullImagesArray.filter((v) => {
      if (isSelectedInsertGallary.includes(v.id)) {
        IdsOne.push(v.id);
      }
    });

    const IdsTwo = [];
    insertClonedArray.filter((v) => {
      if (selectedInsertImages.includes(v.id)) {
        IdsTwo.push(v.id);
      }
    });

    const allSelectedImages = [...IdsOne, ...IdsTwo];
    var item = fullImagesArray.filter((f)=> allSelectedImages.includes(f.id) && f.shared);
    if((item.length>0 && getPrivilegeAction) || (allSelectedImages.length>0 && item.length<=0)) {
      const payload = { imageIds: allSelectedImages };

      dispatch(COMMON_SERVICES.deleteImagesServices(payload, siteId.get())).then(
        () => {
          navigate(0);
        }
      );
    }
    
    setOpenDelete(false)
  }

  const handleClick = () => {
    setActiveButton(false);
    setAddNewImage((current) => !current);
  }

  const saveImageDesc = () => {
    setActiveButton(false);
    dispatch(
      COMMON_SERVICES.putImageDescriptionServices({
        inputDesc: imagesData?.payload1,
        imgId: imagesData?.payload4,
      })
    ).then(() => {
      dispatch(COMMON_SERVICES.getImageGalleryServices(siteId.get()));
    });
    setAddNewImage((current) => !current);
  }

  function renderEditImageDesc(payload1, payload2, payload3, payload4) {
    setAddNewImage(!addNewImage);
    setImagesData({ payload1, payload2, payload3, payload4 });
  }

  function verboseDateToString(vd, format) {
    var m = moment(
      new Date(
        Date.UTC(
          vd?.year,
          vd?.month - 1,
          vd?.day,
          vd?.hour,
          vd?.minute,
          vd?.second
        )
      )
    );
    if (format) {
      return m.format(format);
    } else {
      return m.format("ddd DD/MMM/YY HH:mm:ss");
    }
  }

  //############## Delete All Images functionality###################//
  function checkModal(evt, arr) {
    setPreviewImageOpen(true);
    const returnedElem =
      arr?.length !== 0 &&
      arr?.filter((item) => {
        return item?.id === Number(evt.target.id);
      });

    setZoomImageState(returnedElem[0].base64data);
  }

  // Add new Image
  const handleAddNewImage = (e) => {
    setSelectedFile(e.target.files[0]);
    setDisableUpload(false);
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = (e) => {
      if (reader.readyState === 2) {
        let img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          setHeight(img.height);
          setWidth(img.width);
        };
      }
    };
  }

  const uploadImg = async (event) => {
    event.preventDefault();
    setUploading(true);

    let fd = new FormData();
    fd.append("file", selectedFile);

    if (allowedHeight.includes(height) && allowedWidth.includes(width)) 
    {
      let response = await addImageApiCall(fd, headersConfigDatafile, sharedImage ? 0 : siteId.get());

      const text = await response.text();

      if (text === "duplicate name") {
        setOpenUploadError(true);
        setUploading(false);
      } else {
        dispatch(COMMON_SERVICES.getImageGalleryServices(siteId.get()));
        setDisableUpload(true);
        setUploading(false);
        setOpenUpload(false);
      }
    } else {
      setUploading(false);
      setAlertTxt(t("Image_should_be_with_the_size_of_1024_X_600_(or)_314_X_141"));
      setAlertModal(true);
    }
  };

  const handleCancel = () => {
    setDisableUpload(true);
    setOpenUpload(false);
  };

  const imageSubtitle = (el) => {
    return <>
            <Typography color="inherit">
              {el?.description}
            </Typography>
          </>;
  }

  if (siteSettingDataReduxStateStatus === API_STATUSES.REQUEST) {
    return <Loader />;
  }

  return (
    <Container>
      <Header>
        <div className="label-wrapper">
          <p className="label-p">{t("Status")}</p>
          <Tooltip title={t("Shared")} className="title">
            <button
              style={{ background: sharedImages ? "#BC9B6A" : "" }}
              onClick={sharedImageChange}
            >
              {t("Shared")}
            </button>
          </Tooltip>
          <Tooltip title={t("Local")} className="title">
            <button
              style={{ background: localImages ? "#BC9B6A" : "" }}
              onClick={localImageChange}
            >
              {t("Local")}
            </button>
          </Tooltip>
        </div>
        <div className="label-wrapper">
          <p className="label-p">{t("Type_of_Image")}</p>
          <Tooltip title={t("Both")} className="title">
            <button
              style={{ background: bothImages ? "#BC9B6A" : "" }}
              onClick={() => {
                setBothImages(true);
                setFullImages(false);
                setInsertImages(false);
                setAddNewImage(false);
              }}
            >
              {t("Both")}
            </button>
          </Tooltip>
          <Tooltip title={t("Full_page")} className="title">
            <button
              style={{ background: fullImages ? "#BC9B6A" : "" }}
              onClick={() => {
                setFullImages(true);
                setBothImages(false);
                setInsertImages(false);
                setAddNewImage(false);
              }}
            >
              {t("Full_page")}
            </button>
          </Tooltip>
          <Tooltip title={t("Insert")} className="title">
            <button
              style={{ background: insertImages ? "#BC9B6A" : "" }}
              onClick={() => {
                setInsertImages(true);
                setBothImages(false);
                setFullImages(false);
                setAddNewImage(false);
              }}
            >
              {t("Insert")}
            </button>
          </Tooltip>
        </div>
        <div className="label-wrapper">
          <p className="label-p">{t("Sort_by")}</p>
          <Box sx={{ minWidth: 120 }} className="dropdown">
            <FormControl fullWidth>
              <NativeSelect
                defaultValue="date"
                onChange={(e) => setDropDownValue(e.target.value)}
              >
                <option value="date">{t("Date_uploaded")}</option>
                <option value="desc">{t("Description")}</option>
                <option value="file">{t("File_name")}</option>
                <option value="size">{t("Image_size")}</option>
              </NativeSelect>
            </FormControl>
          </Box>
        </div>
      </Header>
      {getImageGalleryStatus === "success" ? (
        <BodySection>
          <BodyHeader>
            <h4>{t("Image_Gallery")}</h4>
            <div className="d-flex-wrapper">
              <Tooltip title={t("Add_New_Image")}>
                <CircleBtn
                  disabled={
                    isUserBasic(getUserRole && getUserRole?.Role) ||
                    isUserReadOnly(getUserRole && getUserRole?.Role)
                  }
                  className="title"
                  onClick={handleOpenUpload}
                >
                  <AddIcon color="#000" />
                  {t("Add_New_Image")}
                </CircleBtn>
              </Tooltip>

              <Modal
                open={openUpload}
                onClose={() => setOpenUpload(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <PopUpContainer>
                    <div className="header">{t("Upload_image")}</div>
                    <Typography id="modal-modal-description" className="txt-align" sx={{ mt: 2 }}>
                      {t("Select_an_image_file_to_upload")} (.jpg){" "}
                      {t("Image_must_be_1024_x_600_or_314_x_141_pixels")}
                    </Typography>
                    <div className="p-inline-15">
                      <form>
                        <UploadBtnWrapper>
                          <input
                            type="file"
                            name="formFile"
                            className="input"
                            onChange={handleAddNewImage}
                            accept=".jpg"
                          ></input>
                        </UploadBtnWrapper>
                      </form>
                      <span style={{ height: "70px" }}>
                        &nbsp;
                        {uploading && <span>{t("Uploading")}...</span>}
                      </span>
                      <div className="action-btn action-btn-align">
                    <div>{(getUserRole && (isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role)) && getPrivilegeAction) ? 
                     <StyledCheckbox className="checkbox">
                        <Tooltip title={t("Share_image_on_all_sites")} className="title">
                          <FormControlLabel
                            label={t("Share_image_on_all_sites")}
                            control={
                              <Checkbox
                                onClick={() => setSharedImage(!sharedImage)}
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                              
                            }
                          />
                        </Tooltip>
                      </StyledCheckbox>:<></>}</div>
                      <div className="addnew-img-btns">
                        <Tooltip title="Upload" className="title">
                          <button
                            type="submit"
                            onClick={(e) => uploadImg(e)}
                            disabled={disableUpload}
                            className={disableUpload ? "" : "primary"}
                          >
                            {t("Upload")}
                          </button>
                        </Tooltip>
                        <Tooltip title={t("Cancel")} className="title">
                          <button onClick={handleCancel}>{t("Cancel")}</button>
                        </Tooltip>
                      </div></div>
                      {selectedFile && <img src={pic}></img>}
                    </div>
                  </PopUpContainer>
                </Box>
              </Modal>

              <Modal
                open={openUploadError}
                onClose={() => setOpenUploadError(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <PopUpContainer>
                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h2"
                    >
                      {t("Error")}
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                      {t("Image_with_that_name_is_already_in_the_gallery")}
                    </Typography>
                    <div>
                      <div className="action-btn">
                        <button
                          type="submit"
                          className="primary"
                          onClick={() => setOpenUploadError(false)}
                        >
                          {t("Ok")}
                        </button>
                      </div>
                    </div>
                  </PopUpContainer>
                </Box>
              </Modal>

              <Modal
                open={alertModal}
                onClose={() => {
                  setAlertModal(false);
                  setAlertTxt("");
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <PopUpContainer>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                      {alertTxt}
                    </Typography>
                    <div>
                      <div className="action-btn">
                        <button
                          className="primary"
                          onClick={() => {
                            setAlertModal(false);
                            setAlertTxt("");
                          }}
                        >
                          {t("Ok")}
                        </button>
                      </div>
                    </div>
                  </PopUpContainer>
                </Box>
              </Modal>
              <Tooltip title={t("Delete_image")}>
                <CircleBtn
                  disabled={
                    deleteDisable ||
                    isUserBasic(getUserRole && getUserRole?.Role) ||
                    isUserReadOnly(getUserRole && getUserRole?.Role)
                  }
                  className="title"
                  onClick={handleDeleteOpen}
                  style={{
                    color: deleteSharedColor? "red":"black",
                  }}
                >
                  <DeleteIcon
                    width={9.62}
                    height={11}
                    color={deleteSharedColor? "red":"black"}
                  />
                  {t("Delete_image")}
                </CircleBtn>
              </Tooltip>
              <Modal
                open={openDelete}
                onClose={() => setOpenDelete(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <PopUpContainer>
                    <h2>{openSharedDelete?t("Confirm_Shared_Delete"):t("Confirm")}</h2>
                    <p>{openSharedDelete?t("Shared_Delete_Desc"):t("Delete_image")}</p>
                    <div className="action-btn">
                      <button
                        className="primary"
                        onClick={deleteImages}
                        variant="contained"
                      >
                        {t("Yes")}
                      </button>
                      <button onClick={() => setOpenDelete(false)}>
                        {t("No")}
                      </button>
                    </div>
                  </PopUpContainer>
                </Box>
              </Modal>
            </div>
          </BodyHeader>
          {addNewImage ? (
            <>
              <AddNewImageWrapper>
                <div className="heading">
                  <h2>{t("Edit_description")}</h2>
                  <AddIcon color="#000" onClick={handleClick} />
                </div>
                <div className="wrapper">
                  <div className="field-container">
                    <div className="image-wrapper">
                      <img
                        src={imagesData?.payload3}
                        className="selected-image"
                        alt="selected-image"
                      />
                      <p className="image-title">{imagesData?.payload2}</p>
                    </div>
                  </div>
                  <div className="field-container">
                    <p className="label-tag">Image {t("Title")}</p>
                    <div className="field title-field">
                      <input
                        type="text"
                        placeholder="Type Title"
                        value={imagesData.payload1}
                        onChange={(e) => {
                          setActiveButton(true);
                          setImagesData({
                            ...imagesData,
                            payload1: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="action-wrapper">
                    <Tooltip title={t("Cancel")}>
                      <CircleBtn
                        color="white"
                        className="circleBtn"
                        onClick={handleClick}
                      >
                        {t("Cancel")}
                      </CircleBtn>
                    </Tooltip>
                    <Tooltip title={t("Save")}>
                      <CircleBtn
                        disabled={
                          !activeButton
                        }
                        className={
                            !activeButton
                            ? "disabled"
                            : "active"
                        }
                        onClick={saveImageDesc}
                      >
                        {t("Save")}
                      </CircleBtn>
                    </Tooltip>
                  </div>
                </div>
              </AddNewImageWrapper>
            </>
          ) : (
            <></>
          )}
          <MainSection>
            <Modal
              open={openPreviewImage}
              onClose={() => setPreviewImageOpen(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <PopUpContainer style={{ paddingBottom: '15px' }}>
                  <div className="header">{t("Preview")}</div>
                  <PreviewImageWrapper>
                    {zoomImageState && (
                      <img src={zoomImageState} alt="images" />
                    )}
                  </PreviewImageWrapper>
                  <div className="action-btn" style={{ marginTop: '15px' }}>
                    <button onClick={() => setPreviewImageOpen(false)}>{t("Close")}</button>

                  </div>
                </PopUpContainer>
              </Box>
            </Modal>
            {bothImages && sharedImages && !localImages ? (
              <>
                <div className="full-image-wrapper">
                  <div className="head">
                    <h6>{t("Full_page")}</h6>
                    {sortAndFilter(dropDownValue, fullImagesArray).length !== 0 &&
                      sortAndFilter(dropDownValue, fullImagesArray).find(
                        (item) => {
                          return item?.shared && item?.fullPage;
                        }
                      ) ? (
                      <StyledCheckbox className="checkbox">
                        <Tooltip title={t("Select_all")} className="title">
                          <FormControlLabel
                            label={t("Select_all")}
                            control={
                              <Checkbox
                                checked={isAllSelectedGallary}
                                onClick={(e) => selectItem(e, "imageGallary")}
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                            }
                          />
                        </Tooltip>
                      </StyledCheckbox>
                    ) : (
                      <></>
                    )}
                  </div>

                  <div className="image-main-wrapper">
                    {sortAndFilter(dropDownValue, fullImagesArray).length !== 0 &&
                      sortAndFilter(dropDownValue, fullImagesArray)
                        .filter((item) => {
                          return item?.shared && item?.fullPage;
                        })
                        .map((el) => {
                          return (
                            <>
                              <div className="image-wrapper">
                                <Checkbox
                                  className="custom-position"
                                  sx={overlayStyle}
                                  key={el?.id}
                                  onClick={() =>
                                    handleCheckboxClick(
                                      el?.id,
                                      "imageGallary",
                                      setSelectedInsertGallary
                                    )
                                  }
                                  checkedList={checkedList}
                                  checked={
                                    isSelectedInsertGallary.includes(el?.id) &&
                                      isAllSelectedGallary
                                      ? true
                                      : isSelectedInsertGallary.includes(el?.id)
                                        ? true
                                        : isAllSelectedGallary
                                  }
                                  icon={<UnCheckIcon width={20} height={20} />}
                                  checkedIcon={
                                    <CheckIcon width={20} height={20} />
                                  }
                                />
                                <Tooltip>
                                  <img
                                    src={el?.base64data}
                                    alt="images"
                                    style={{
                                      marginTop: 30,
                                      opacity:
                                        isSelectedInsertGallary.length > 0
                                          ? isSelectedInsertGallary.includes(
                                            el?.id
                                          )
                                            ? "1"
                                            : "0.5"
                                          : "1",
                                    }}
                                  />
                                </Tooltip>
                                <div className="overlay">
                                  <StyledCheckbox className="checkbox"></StyledCheckbox>
                                  <div className="edit-wrapper">
                                    {(el?.shared && (isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role))) || (!el?.shared && !(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role))) ?
                                    <Tooltip title={t("Edit_description")}>
                                      <button
                                        name={el?.id}
                                        onClick={() =>
                                          renderEditImageDesc(
                                            el?.description,
                                            el?.filename,
                                            el?.base64data,
                                            el?.id
                                          )
                                        }
                                      >
                                       <EditIcon
                                          color="#fff"
                                          width={9.34}
                                          height={9.34}
                                        />
                                      </button>
                                    </Tooltip>
                                    :<></>
                        }
                                    <Tooltip title={t("View_full_size")}>
                                      <button
                                        id={el?.id}
                                        className="zoom-icon"
                                        onClick={(e) =>
                                          checkModal(e, fullImagesArray)
                                        }
                                      >
                                        <ZoomIcon
                                          color="#fff"
                                          width={9.34}
                                          height={9.34}
                                          pointerEvents="none"
                                        />
                                      </button>
                                    </Tooltip>
                                  </div>
                                </div>
                                <div className="imageSubtitle">{imageSubtitle(el)}</div>
                              </div>
                            </>
                          );
                        })}
                  </div>
                </div>
                <div className="insert-image-wrapper">
                  <div className="head">
                    <h6>{t("Insert")}</h6>
                    {sortAndFilter(dropDownValue, insertClonedArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, insertClonedArray).find(
                        (item) => {
                          return item?.shared;
                        }
                      ) ? (
                      <StyledCheckbox className="checkbox">
                        <Tooltip title={t("Select_all")} className="title">
                          <FormControlLabel
                            label={t("Select_all")}
                            control={
                              <Checkbox
                                checked={isAllInsertImages}
                                onClick={(e) => selectItem(e, "insertImage")}
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                            }
                          />
                        </Tooltip>
                      </StyledCheckbox>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="image-main-wrapper">
                    {sortAndFilter(dropDownValue, insertClonedArray).length !== 0 &&
                      sortAndFilter(dropDownValue, insertClonedArray)
                        .filter((item) => {
                          return item?.shared;
                        })
                        .map((el) => {
                          return (
                            <Tooltip>
                              <div className="image-wrapper">
                                <Checkbox
                                  className="custom-position"
                                  sx={overlayStyle}
                                  key={el?.id}
                                  onClick={() =>
                                    handleCheckboxClick(
                                      el.id,
                                      "insertImage",
                                      setSelectedInsertImages
                                    )
                                  }
                                  checkedList={checkedList}
                                  checked={
                                    selectedInsertImages.includes(el?.id) &&
                                      isAllInsertImages
                                      ? true
                                      : selectedInsertImages.includes(el?.id)
                                        ? true
                                        : isAllInsertImages
                                  }
                                  icon={<UnCheckIcon width={20} height={20} />}
                                  checkedIcon={
                                    <CheckIcon width={20} height={20} />
                                  }
                                />
                                <img
                                  src={el?.base64data}
                                  alt="images"
                                  style={{
                                    marginTop: 30,
                                    opacity:
                                      selectedInsertImages.length > 0
                                        ? selectedInsertImages.includes(el?.id)
                                          ? "1"
                                          : "0.5"
                                        : "1",
                                  }}
                                />
                                <div className="overlay">
                                  <StyledCheckbox className="checkbox"></StyledCheckbox>
                                  <div className="edit-wrapper">
                                  {(el?.shared && (isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role))) || (!el?.shared && !(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role))) ?<Tooltip title={t("Edit_description")}>
                                      <button
                                        name={el?.id}
                                        onClick={() =>
                                          renderEditImageDesc(
                                            el?.description,
                                            el?.filename,
                                            el?.base64data,
                                            el?.id
                                          )
                                        }
                                      >
                                        <EditIcon
                                          color="#fff"
                                          width={9.34}
                                          height={9.34}
                                        />
                                      </button>
                                    </Tooltip>:<></>}
                                    <Tooltip title={t("View_full_size")}>
                                      <button
                                        id={el?.id}
                                        className="zoom-icon"
                                        onClick={(e) =>
                                          checkModal(e, insertClonedArray)
                                        }
                                      >
                                        <ZoomIcon
                                          color="#fff"
                                          width={9.34}
                                          height={9.34}
                                          pointerEvents="none"
                                        />
                                      </button>
                                    </Tooltip>
                                  </div>
                                </div>
                                <div className="imageSubtitle">{imageSubtitle(el)}</div>
                              </div>
                            </Tooltip>
                          );
                        })}
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}

            {bothImages && localImages && !sharedImages ? (
              <>
                <div className="full-image-wrapper">
                  <div className="head">
                    <h6>{t("Full_page")}</h6>
                    {sortAndFilter(dropDownValue, fullImagesArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, fullImagesArray).find(
                        (item) => {
                          return !item?.shared && item?.fullPage;
                        }
                      ) ? (
                      <StyledCheckbox className="checkbox">
                        <Tooltip title={t("Select_all")} className="title">
                          <FormControlLabel
                            label={t("Select_all")}
                            control={
                              <Checkbox
                                checked={isAllSelectedGallary}
                                onClick={(e) => selectItem(e, "imageGallary")}
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                            }
                          />
                        </Tooltip>
                      </StyledCheckbox>
                    ) : (
                      <></>
                    )}
                  </div>

                  <div className="image-main-wrapper">
                    {sortAndFilter(dropDownValue, fullImagesArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, fullImagesArray)
                        .filter((item) => {
                          return !item?.shared && item?.fullPage;
                        })
                        .map((el) => {
                          return (
                            <>
                              <div className="image-wrapper">
                                <Checkbox
                                  className="custom-position"
                                  sx={overlayStyle}
                                  key={el?.id}
                                  onClick={() =>
                                    handleCheckboxClick(
                                      el?.id,
                                      "imageGallary",
                                      setSelectedInsertGallary
                                    )
                                  }
                                  checkedList={checkedList}
                                  checked={
                                    isSelectedInsertGallary.includes(el?.id) &&
                                      isAllSelectedGallary
                                      ? true
                                      : isSelectedInsertGallary.includes(el?.id)
                                        ? true
                                        : isAllSelectedGallary
                                  }
                                  icon={<UnCheckIcon width={20} height={20} />}
                                  checkedIcon={
                                    <CheckIcon width={20} height={20} />
                                  }
                                />
                                <div className="overlay">
                                  <StyledCheckbox className="checkbox"></StyledCheckbox>
                                  <div className="edit-wrapper">
                                  {(el?.shared && (isUserAdmin(getUserRole && getUserRole?.Role)||isUserSupport(getUserRole && getUserRole?.Role))) || (!el?.shared &&  !(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role))) ?  <Tooltip title={t("Edit_description")}>
                                      <button
                                        name={el?.id}
                                        onClick={() =>
                                          renderEditImageDesc(
                                            el?.description,
                                            el?.filename,
                                            el?.base64data,
                                            el?.id
                                          )
                                        }
                                      >
                                        <EditIcon
                                          color="#fff"
                                          width={9.34}
                                          height={9.34}
                                        />
                                      </button>
                                    </Tooltip>:<></>}
                                    <Tooltip title={t("View_full_size")}>
                                      <button
                                        id={el?.id}
                                        className="zoom-icon"
                                        onClick={(e) =>
                                          checkModal(e, fullImagesArray)
                                        }
                                      >
                                        <ZoomIcon
                                          color="#fff"
                                          width={9.34}
                                          height={9.34}
                                          pointerEvents="none"
                                        />
                                      </button>
                                    </Tooltip>
                                  </div>
                                </div>
                                <p className="imgTitle">{el?.filename}</p>
                                <Tooltip>
                                  <img
                                    src={el?.base64data}
                                    alt="images"
                                    style={{
                                      marginTop: 30,
                                      opacity:
                                        isSelectedInsertGallary.length > 0
                                          ? isSelectedInsertGallary.includes(
                                            el?.id
                                          )
                                            ? "1"
                                            : "0.5"
                                          : "1",
                                    }}
                                  />
                                </Tooltip>

                                <div className="uploadedDateInfo">
                                  <strong>Uploaded on</strong>{" "}
                                  {verboseDateToString(
                                    el?.uploadedUtc,
                                    "DD/MMM/YY"
                                  )}{" "}
                                  || {el?.size}
                                </div>
                                <div className="imageSubtitle">{imageSubtitle(el)}</div>
                              </div>
                            </>
                          );
                        })}
                  </div>
                </div>
                <div className="insert-image-wrapper">
                  <div className="head">
                    <h6>{t("Insert")}</h6>
                    {sortAndFilter(dropDownValue, insertClonedArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, insertClonedArray).find(
                        (item) => {
                          return !item?.shared;
                        }
                      ) ? (
                      <StyledCheckbox className="checkbox">
                        <Tooltip title={t("Select_all")} className="title">
                          <FormControlLabel
                            label={t("Select_all")}
                            control={
                              <Checkbox
                                checked={isAllInsertImages}
                                onClick={(e) => selectItem(e, "insertImage")}
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                            }
                          />
                        </Tooltip>
                      </StyledCheckbox>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="image-main-wrapper">
                    {sortAndFilter(dropDownValue, insertClonedArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, insertClonedArray)
                        .filter((item) => {
                          return !item?.shared;
                        })
                        .map((el) => {
                          return (
                            <Tooltip>
                              <div className="image-wrapper">
                                <Checkbox
                                  className="custom-position"
                                  sx={overlayStyle}
                                  key={el?.id}
                                  onClick={() =>
                                    handleCheckboxClick(
                                      el.id,
                                      "insertImage",
                                      setSelectedInsertImages
                                    )
                                  }
                                  checkedList={checkedList}
                                  checked={
                                    selectedInsertImages.includes(el?.id) &&
                                      isAllInsertImages
                                      ? true
                                      : selectedInsertImages.includes(el?.id)
                                        ? true
                                        : isAllInsertImages
                                  }
                                  icon={<UnCheckIcon width={20} height={20} />}
                                  checkedIcon={
                                    <CheckIcon width={20} height={20} />
                                  }
                                />
                                <p className="imgTitle">{el?.filename}</p>
                                <img
                                  src={el?.base64data}
                                  alt="images"
                                  style={{
                                    marginTop: 30,
                                    opacity:
                                      selectedInsertImages.length > 0
                                        ? selectedInsertImages.includes(el?.id)
                                          ? "1"
                                          : "0.5"
                                        : "1",
                                  }}
                                />
                                <div className="uploadedDateInfo">
                                  <strong>Uploaded on</strong>{" "}
                                  {verboseDateToString(
                                    el?.uploadedUtc,
                                    "DD/MMM/YY"
                                  )}{" "}
                                  || {el?.size}
                                </div>
                                <div className="overlay">
                                  <StyledCheckbox className="checkbox"></StyledCheckbox>
                                  <div className="edit-wrapper">
                                  {(el?.shared && (isUserAdmin(getUserRole && getUserRole?.Role)||isUserSupport(getUserRole && getUserRole?.Role))) || (!el?.shared && !(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role))) ? <Tooltip title={t("Edit_description")}>
                                      <button
                                        name={el?.id}
                                        onClick={() =>
                                          renderEditImageDesc(
                                            el?.description,
                                            el?.filename,
                                            el?.base64data,
                                            el?.id
                                          )
                                        }
                                      >
                                        <EditIcon
                                          color="#fff"
                                          width={9.34}
                                          height={9.34}
                                        />
                                      </button>
                                    </Tooltip>:<></>}
                                    <Tooltip title={t("View_full_size")}>
                                      <button
                                        id={el?.id}
                                        className="zoom-icon"
                                        onClick={(e) =>
                                          checkModal(e, insertClonedArray)
                                        }
                                      >
                                        <ZoomIcon
                                          color="#fff"
                                          width={9.34}
                                          height={9.34}
                                          pointerEvents="none"
                                        />
                                      </button>
                                    </Tooltip>
                                  </div>
                                </div>
                                <div className="imageSubtitle">{imageSubtitle(el)}</div>
                              </div>
                            </Tooltip>
                          );
                        })}
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}

            {bothImages && localImages && sharedImages ? (
              <>
                <div className="full-image-wrapper">
                  <div className="head">
                    <h6>{t("Full_page")}</h6>
                    {sortAndFilter(dropDownValue, fullImagesArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, fullImagesArray).find(
                        (item) => {
                          return item?.fullPage;
                        }
                      ) ? (
                      <StyledCheckbox className="checkbox">
                        <Tooltip title={t("Select_all")} className="title">
                          <FormControlLabel
                            label={t("Select_all")}
                            control={
                              <Checkbox
                                checked={isAllSelectedGallary}
                                onClick={(e) => selectItem(e, "imageGallary")}
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                            }
                          />
                        </Tooltip>
                      </StyledCheckbox>
                    ) : (
                      <></>
                    )}
                  </div>

                  <div className="image-main-wrapper">
                    {sortAndFilter(dropDownValue, fullImagesArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, fullImagesArray)
                        .filter((item) => {
                          return item?.fullPage;
                        })
                        .map((el) => {
                          return (
                            <>
                              <div className="image-wrapper">
                                <Checkbox
                                  className="custom-position"
                                  sx={overlayStyle}
                                  key={el?.id}
                                  onClick={() =>
                                    handleCheckboxClick(
                                      el?.id,
                                      "imageGallary",
                                      setSelectedInsertGallary
                                    )
                                  }
                                  checkedList={checkedList}
                                  checked={
                                    isSelectedInsertGallary.includes(el?.id) &&
                                      isAllSelectedGallary
                                      ? true
                                      : isSelectedInsertGallary.includes(el?.id)
                                        ? true
                                        : isAllSelectedGallary
                                  }
                                  icon={<UnCheckIcon width={20} height={20} />}
                                  checkedIcon={
                                    <CheckIcon width={20} height={20} />
                                  }
                                />
                                <div className="overlay">
                                  <StyledCheckbox className="checkbox"></StyledCheckbox>
                                  <div className="edit-wrapper">
                                  {(el?.shared && (isUserAdmin(getUserRole && getUserRole?.Role)||isUserSupport(getUserRole && getUserRole?.Role))) || (!el?.shared && !(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role))) ? <Tooltip title={t("Edit_description")}>
                                      <button
                                        name={el?.id}
                                        onClick={() =>
                                          renderEditImageDesc(
                                            el?.description,
                                            el?.filename,
                                            el?.base64data,
                                            el?.id
                                          )
                                        }
                                      >
                                        <EditIcon
                                          color="#fff"
                                          width={9.34}
                                          height={9.34}
                                        />
                                      </button>
                                    </Tooltip>:<></>}
                                    <Tooltip title={t("View_full_size")}>
                                      <button
                                        id={el?.id}
                                        className="zoom-icon"
                                        onClick={(e) =>
                                          checkModal(e, fullImagesArray)
                                        }
                                      >
                                        <ZoomIcon
                                          color="#fff"
                                          width={9.34}
                                          height={9.34}
                                          pointerEvents="none"
                                        />
                                      </button>
                                    </Tooltip>
                                  </div>
                                </div>
                                <p className="imgTitle">{el?.filename}</p>
                                <Tooltip>
                                  <img
                                    src={el?.base64data}
                                    alt="images"
                                    style={{
                                      marginTop: 30,
                                      opacity:
                                        isSelectedInsertGallary.length > 0
                                          ? isSelectedInsertGallary.includes(
                                            el?.id
                                          )
                                            ? "1"
                                            : "0.5"
                                          : "1",
                                    }}
                                  />
                                </Tooltip>
                                <div className="uploadedDateInfo">
                                  <strong>Uploaded on</strong>{" "}
                                  {verboseDateToString(
                                    el?.uploadedUtc,
                                    "DD/MMM/YY"
                                  )}{" "}
                                  || {el?.size}
                                </div>
                                <div className="imageSubtitle">{imageSubtitle(el)}</div>
                              </div>
                            </>
                          );
                        })}
                  </div>
                </div>
                <div className="insert-image-wrapper">
                  <div className="head">
                    <h6>{t("Insert")} </h6>
                    {sortAndFilter(dropDownValue, insertClonedArray).length !==
                      0 ? (
                      <StyledCheckbox className="checkbox">
                        <Tooltip title={t("Select_all")} className="title">
                          <FormControlLabel
                            label={t("Select_all")}
                            control={
                              <Checkbox
                                checked={isAllInsertImages}
                                onClick={(e) => selectItem(e, "insertImage")}
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                            }
                          />
                        </Tooltip>
                      </StyledCheckbox>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="image-main-wrapper">
                    {sortAndFilter(dropDownValue, insertClonedArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, insertClonedArray).map(
                        (el) => {
                          return (
                            <div className="image-wrapper">
                              <Checkbox
                                className="custom-position"
                                sx={overlayStyle}
                                key={el?.id}
                                onClick={() =>
                                  handleCheckboxClick(
                                    el.id,
                                    "insertImage",
                                    setSelectedInsertImages
                                  )
                                }
                                checkedList={checkedList}
                                checked={
                                  selectedInsertImages.includes(el?.id) &&
                                    isAllInsertImages
                                    ? true
                                    : selectedInsertImages.includes(el?.id)
                                      ? true
                                      : isAllInsertImages
                                }
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                              <p className="imgTitle">{el?.filename}</p>
                              <Tooltip>
                                <img
                                  src={el?.base64data}
                                  alt="images"
                                  style={{
                                    marginTop: 30,
                                    opacity:
                                      selectedInsertImages.length > 0
                                        ? selectedInsertImages.includes(el?.id)
                                          ? "1"
                                          : "0.5"
                                        : "1",
                                  }}
                                />
                              </Tooltip>
                              <div className="uploadedDateInfo">
                                <strong>Uploaded on</strong>{" "}
                                {verboseDateToString(
                                  el?.uploadedUtc,
                                  "DD/MMM/YY"
                                )}{" "}
                                || {el?.size}
                              </div>

                              <div className="overlay">
                                <StyledCheckbox className="checkbox"></StyledCheckbox>
                                <div className="edit-wrapper">
                                {(el?.shared && (isUserAdmin(getUserRole && getUserRole?.Role)||isUserSupport(getUserRole && getUserRole?.Role))) || (!el?.shared && !(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role))) ?  <Tooltip title={t("Edit_description")}>
                                    <button
                                      name={el?.id}
                                      onClick={() =>
                                        renderEditImageDesc(
                                          el?.description,
                                          el?.filename,
                                          el?.base64data,
                                          el?.id
                                        )
                                      }
                                    >
                                      <EditIcon
                                        color="#fff"
                                        width={9.34}
                                        height={9.34}
                                      />
                                    </button>
                                  </Tooltip>:<></>}
                                  <Tooltip title={t("View_full_size")}>
                                    <button
                                      id={el?.id}
                                      className="zoom-icon"
                                      onClick={(e) =>
                                        checkModal(e, insertClonedArray)
                                      }
                                    >
                                      <ZoomIcon
                                        color="#fff"
                                        width={9.34}
                                        height={9.34}
                                        pointerEvents="none"
                                      />
                                    </button>
                                  </Tooltip>
                                </div>
                              </div>
                              <div className="imageSubtitle">{imageSubtitle(el)}</div>
                            </div>
                          );
                        }
                      )}
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}

            {fullImages && sharedImages && !localImages ? (
              <>
                <div className="full-image-wrapper">
                  <div className="head">
                    <h6>{t("Full_page")}</h6>
                    {sortAndFilter(dropDownValue, fullImagesArray)?.length !==
                      0 &&
                      sortAndFilter(dropDownValue, fullImagesArray).find(
                        (item) => {
                          if (item?.fullPage) {
                            return item?.shared;
                          }
                        }
                      ) ? (
                      <StyledCheckbox className="checkbox">
                        <Tooltip title={t("Select_all")} className="title">
                          <FormControlLabel
                            label={t("Select_all")}
                            control={
                              <Checkbox
                                checked={isAllSelectedGallary}
                                onClick={(e) => selectItem(e, "imageGallary")}
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                            }
                          />
                        </Tooltip>
                      </StyledCheckbox>
                    ) : (
                      <></>
                    )}
                  </div>

                  <div className="image-main-wrapper">
                    {sortAndFilter(dropDownValue, fullImagesArray)?.length !==
                      0 &&
                      sortAndFilter(dropDownValue, fullImagesArray)
                        .filter((item) => {
                          if (item?.fullPage) {
                            return item?.shared;
                          }
                        })
                        ?.map((el) => {
                          return (
                            <div className="image-wrapper">
                              <Checkbox
                                className="custom-position"
                                sx={overlayStyle}
                                key={el?.id}
                                onClick={() =>
                                  handleCheckboxClick(
                                    el?.id,
                                    "imageGallary",
                                    setSelectedInsertGallary
                                  )
                                }
                                checkedList={checkedList}
                                checked={
                                  isSelectedInsertGallary.includes(el?.id) &&
                                    isAllSelectedGallary
                                    ? true
                                    : isSelectedInsertGallary.includes(el?.id)
                                      ? true
                                      : isAllSelectedGallary
                                }
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                              <p className="imgTitle">{el?.filename}</p>
                              <Tooltip>
                                <img
                                  src={el?.base64data}
                                  alt="images"
                                  style={{
                                    marginTop: 30,
                                    opacity:
                                      isSelectedInsertGallary.length > 0
                                        ? isSelectedInsertGallary.includes(
                                          el?.id
                                        )
                                          ? "1"
                                          : "0.5"
                                        : "1",
                                  }}
                                />
                              </Tooltip>
                              <div className="uploadedDateInfo">
                                <strong>Uploaded on</strong>{" "}
                                {verboseDateToString(
                                  el?.uploadedUtc,
                                  "DD/MMM/YY"
                                )}{" "}
                                || {el?.size}
                              </div>
                              <div className="overlay">
                                <StyledCheckbox className="checkbox"></StyledCheckbox>
                                <div className="edit-wrapper">
                                {(el?.shared && (isUserAdmin(getUserRole && getUserRole?.Role)||isUserSupport(getUserRole && getUserRole?.Role))) || (!el?.shared && !(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role))) ? <Tooltip title={t("Edit_description")}>
                                    <button
                                      name={el?.id}
                                      onClick={() =>
                                        renderEditImageDesc(
                                          el?.description,
                                          el?.filename,
                                          el?.base64data,
                                          el?.id
                                        )
                                      }
                                    >
                                      <EditIcon
                                        color="#fff"
                                        width={9.34}
                                        height={9.34}
                                      />
                                    </button>
                                  </Tooltip>:<></>}
                                  <Tooltip title={t("View_full_size")}>
                                    <button
                                      id={el?.id}
                                      className="zoom-icon"
                                      onClick={(e) =>
                                        checkModal(e, fullImagesArray)
                                      }
                                    >
                                      <ZoomIcon
                                        color="#fff"
                                        width={9.34}
                                        height={9.34}
                                        pointerEvents="none"
                                      />
                                    </button>
                                  </Tooltip>
                                </div>
                              </div>
                              <div className="imageSubtitle">{imageSubtitle(el)}</div>
                            </div>
                          );
                        })}
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}

            {fullImages && !sharedImages && localImages ? (
              <>
                <div className="full-image-wrapper">
                  <div className="head">
                    <h6>{t("Full_page")}</h6>
                    {sortAndFilter(dropDownValue, fullImagesArray)?.length !==
                      0 &&
                      sortAndFilter(dropDownValue, fullImagesArray).find(
                        (item) => {
                          if (item?.fullPage) {
                            return !item?.shared;
                          }
                        }
                      ) ? (
                      <StyledCheckbox className="checkbox">
                        <Tooltip title={t("Select_all")} className="title">
                          <FormControlLabel
                            label={t("Select_all")}
                            control={
                              <Checkbox
                                checked={isAllSelectedGallary}
                                onClick={(e) => selectItem(e, "imageGallary")}
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                            }
                          />
                        </Tooltip>
                      </StyledCheckbox>
                    ) : (
                      <></>
                    )}
                  </div>

                  <div className="image-main-wrapper">
                    {sortAndFilter(dropDownValue, fullImagesArray)?.length !==
                      0 &&
                      sortAndFilter(dropDownValue, fullImagesArray)
                        .filter((item) => {
                          if (item?.fullPage) {
                            return !item?.shared;
                          }
                        })
                        ?.map((el) => {
                          return (
                            <div className="image-wrapper">
                              <Checkbox
                                className="custom-position"
                                sx={overlayStyle}
                                key={el?.id}
                                onClick={() =>
                                  handleCheckboxClick(
                                    el?.id,
                                    "imageGallary",
                                    setSelectedInsertGallary
                                  )
                                }
                                checkedList={checkedList}
                                checked={
                                  isSelectedInsertGallary.includes(el?.id) &&
                                    isAllSelectedGallary
                                    ? true
                                    : isSelectedInsertGallary.includes(el?.id)
                                      ? true
                                      : isAllSelectedGallary
                                }
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                              <p className="imgTitle">{el?.filename}</p>
                              <Tooltip>
                                <img
                                  src={el?.base64data}
                                  alt="images"
                                  style={{
                                    marginTop: 30,
                                    opacity:
                                      isSelectedInsertGallary.length > 0
                                        ? isSelectedInsertGallary.includes(
                                          el?.id
                                        )
                                          ? "1"
                                          : "0.5"
                                        : "1",
                                  }}
                                />
                              </Tooltip>
                              <div className="uploadedDateInfo">
                                <strong>Uploaded on</strong>{" "}
                                {verboseDateToString(
                                  el?.uploadedUtc,
                                  "DD/MMM/YY"
                                )}{" "}
                                || {el?.size}
                              </div>

                              <div className="overlay">
                                <StyledCheckbox className="checkbox"></StyledCheckbox>
                                <div className="edit-wrapper">
                                {(el?.shared && (isUserAdmin(getUserRole && getUserRole?.Role)||isUserSupport(getUserRole && getUserRole?.Role))) || (!el?.shared && !(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role))) ?  <Tooltip title={t("Edit_description")}>
                                    <button
                                      name={el?.id}
                                      onClick={() =>
                                        renderEditImageDesc(
                                          el?.description,
                                          el?.filename,
                                          el?.base64data,
                                          el?.id
                                        )
                                      }
                                    >
                                      <EditIcon
                                        color="#fff"
                                        width={9.34}
                                        height={9.34}
                                      />
                                    </button>
                                  </Tooltip>:<></>}
                                  <Tooltip title={t("View_full_size")}>
                                    <button
                                      id={el?.id}
                                      className="zoom-icon"
                                      onClick={(e) =>
                                        checkModal(e, fullImagesArray)
                                      }
                                    >
                                      <ZoomIcon
                                        color="#fff"
                                        width={9.34}
                                        height={9.34}
                                        pointerEvents="none"
                                      />
                                    </button>
                                  </Tooltip>
                                </div>
                              </div>
                              <div className="imageSubtitle">{imageSubtitle(el)}</div>
                            </div>
                          );
                        })}
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}

            {fullImages && sharedImages && localImages ? (
              <>
                <div className="full-image-wrapper">
                  <div className="head">
                    <h6>{t("Full_page")}</h6>
                    {sortAndFilter(dropDownValue, fullImagesArray)?.length !==
                      0 &&
                      sortAndFilter(dropDownValue, fullImagesArray).find(
                        (item) => {
                          return item?.fullPage;
                        }
                      ) ? (
                      <StyledCheckbox className="checkbox">
                        <Tooltip title={t("Select_all")} className="title">
                          <FormControlLabel
                            label={t("Select_all")}
                            control={
                              <Checkbox
                                checked={isAllSelectedGallary}
                                onClick={(e) => selectItem(e, "imageGallary")}
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                            }
                          />
                        </Tooltip>
                      </StyledCheckbox>
                    ) : (
                      <></>
                    )}
                  </div>

                  <div className="image-main-wrapper">
                    {sortAndFilter(dropDownValue, fullImagesArray)?.length !==
                      0 &&
                      sortAndFilter(dropDownValue, fullImagesArray)
                        .filter((item) => {
                          return item?.fullPage;
                        })
                        ?.map((el) => {
                          return (
                            <div className="image-wrapper">
                              <Checkbox
                                className="custom-position"
                                sx={overlayStyle}
                                key={el?.id}
                                onClick={() =>
                                  handleCheckboxClick(
                                    el?.id,
                                    "imageGallary",
                                    setSelectedInsertGallary
                                  )
                                }
                                checkedList={checkedList}
                                checked={
                                  isSelectedInsertGallary.includes(el?.id) &&
                                    isAllSelectedGallary
                                    ? true
                                    : isSelectedInsertGallary.includes(el?.id)
                                      ? true
                                      : isAllSelectedGallary
                                }
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                              <p className="imgTitle">{el?.filename}</p>
                              <Tooltip>
                                <img
                                  src={el?.base64data}
                                  alt="images"
                                  style={{
                                    marginTop: 30,
                                    opacity:
                                      isSelectedInsertGallary.length > 0
                                        ? isSelectedInsertGallary.includes(
                                          el?.id
                                        )
                                          ? "1"
                                          : "0.5"
                                        : "1",
                                  }}
                                />
                              </Tooltip>
                              <div className="uploadedDateInfo">
                                <strong>Uploaded on</strong>{" "}
                                {verboseDateToString(
                                  el?.uploadedUtc,
                                  "DD/MMM/YY"
                                )}{" "}
                                || {el?.size}
                              </div>
                              <div className="overlay">
                                <StyledCheckbox className="checkbox"></StyledCheckbox>
                                <div className="edit-wrapper">
                                {(el?.shared && (isUserAdmin(getUserRole && getUserRole?.Role)||getUserRole?.Role === userRoles.support)) || (!el?.shared && !(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role))) ? <Tooltip title={t("Edit_description")}>
                                    <button
                                      name={el?.id}
                                      onClick={() =>
                                        renderEditImageDesc(
                                          el?.description,
                                          el?.filename,
                                          el?.base64data,
                                          el?.id
                                        )
                                      }
                                    >
                                      <EditIcon
                                        color="#fff"
                                        width={9.34}
                                        height={9.34}
                                      />
                                    </button>
                                  </Tooltip>:<></>}
                                  <Tooltip title={t("View_full_size")}>
                                    <button
                                      id={el?.id}
                                      className="zoom-icon"
                                      onClick={(e) =>
                                        checkModal(e, fullImagesArray)
                                      }
                                    >
                                      <ZoomIcon
                                        color="#fff"
                                        width={9.34}
                                        height={9.34}
                                        pointerEvents="none"
                                      />
                                    </button>
                                  </Tooltip>
                                </div>
                              </div>
                              <div className="imageSubtitle">{imageSubtitle(el)}</div>
                            </div>
                          );
                        })}
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}

            {insertImages && sharedImages && !localImages ? (
              <>
                <div className="insert-image-wrapper">
                  <div className="head">
                    <h6>{t("Insert")}</h6>
                    {sortAndFilter(dropDownValue, insertClonedArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, insertClonedArray).find(
                        (item) => {
                          if (!item?.fullPage) {
                            return item?.shared;
                          }
                        }
                      ) ? (
                      <StyledCheckbox className="checkbox">
                        <Tooltip title={t("Select_all")} className="title">
                          <FormControlLabel
                            label={t("Select_all")}
                            control={
                              <Checkbox
                                checked={isAllInsertImages}
                                onClick={(e) => selectItem(e, "insertImage")}
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                            }
                          />
                        </Tooltip>
                      </StyledCheckbox>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="image-main-wrapper">
                    {sortAndFilter(dropDownValue, insertClonedArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, insertClonedArray)
                        .filter((item) => {
                          if (!item?.fullPage) {
                            return item?.shared;
                          }
                        })
                        .map((el) => {
                          return (
                            <div className="image-wrapper">
                              <Checkbox
                                className="custom-position"
                                sx={overlayStyle}
                                key={el?.id}
                                onClick={() =>
                                  handleCheckboxClick(
                                    el.id,
                                    "insertImage",
                                    setSelectedInsertImages
                                  )
                                }
                                checkedList={checkedList}
                                checked={
                                  selectedInsertImages.includes(el?.id) &&
                                    isAllInsertImages
                                    ? true
                                    : selectedInsertImages.includes(el?.id)
                                      ? true
                                      : isAllInsertImages
                                }
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                              <p className="imgTitle">{el?.filename}</p>
                              <Tooltip>
                                <img
                                  src={el?.base64data}
                                  alt="images"
                                  style={{
                                    marginTop: 30,
                                    opacity:
                                      selectedInsertImages.length > 0
                                        ? selectedInsertImages.includes(el?.id)
                                          ? "1"
                                          : "0.5"
                                        : "1",
                                  }}
                                />
                              </Tooltip>
                              <div className="uploadedDateInfo">
                                <strong>Uploaded on</strong>{" "}
                                {verboseDateToString(
                                  el?.uploadedUtc,
                                  "DD/MMM/YY"
                                )}{" "}
                                || {el?.size}
                              </div>
                              <div className="overlay">
                                <StyledCheckbox className="checkbox"></StyledCheckbox>
                                <div className="edit-wrapper">
                                {(el?.shared && (isUserAdmin(getUserRole && getUserRole?.Role)||isUserSupport(getUserRole && getUserRole?.Role))) || (!el?.shared && !(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role))) ? <Tooltip title={t("Edit_description")}>
                                    <button
                                      name={el?.id}
                                      onClick={() =>
                                        renderEditImageDesc(
                                          el?.description,
                                          el?.filename,
                                          el?.base64data,
                                          el?.id
                                        )
                                      }
                                    >
                                      <EditIcon
                                        color="#fff"
                                        width={9.34}
                                        height={9.34}
                                      />
                                    </button>
                                  </Tooltip>:<></>}
                                  <Tooltip title={t("View_full_size")}>
                                    <button
                                      id={el?.id}
                                      className="zoom-icon"
                                      onClick={(e) =>
                                        checkModal(e, insertClonedArray)
                                      }
                                    >
                                      <ZoomIcon
                                        color="#fff"
                                        width={9.34}
                                        height={9.34}
                                        pointerEvents="none"
                                      />
                                    </button>
                                  </Tooltip>
                                </div>
                              </div>
                              <div className="imageSubtitle">{imageSubtitle(el)}</div>
                            </div>
                          );
                        })}
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}

            {insertImages && !sharedImages && localImages ? (
              <>
                <div className="insert-image-wrapper">
                  <div className="head">
                    <h6>{t("Insert")} </h6>
                    {sortAndFilter(dropDownValue, insertClonedArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, insertClonedArray).find(
                        (item) => {
                          if (!item?.fullPage) {
                            return !item?.shared;
                          }
                        }
                      ) ? (
                      <StyledCheckbox className="checkbox">
                        <Tooltip title={t("Select_all")} className="title">
                          <FormControlLabel
                            label={t("Select_all")}
                            control={
                              <Checkbox
                                checked={isAllInsertImages}
                                onClick={(e) => selectItem(e, "insertImage")}
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                            }
                          />
                        </Tooltip>
                      </StyledCheckbox>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="image-main-wrapper">
                    {sortAndFilter(dropDownValue, insertClonedArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, insertClonedArray)
                        .filter((item) => {
                          if (!item?.fullPage) {
                            return !item?.shared;
                          }
                        })
                        .map((el) => {
                          return (
                            <div className="image-wrapper">
                              <Checkbox
                                className="custom-position"
                                sx={overlayStyle}
                                key={el?.id}
                                onClick={() =>
                                  handleCheckboxClick(
                                    el.id,
                                    "insertImage",
                                    setSelectedInsertImages
                                  )
                                }
                                checkedList={checkedList}
                                checked={
                                  selectedInsertImages.includes(el?.id) &&
                                    isAllInsertImages
                                    ? true
                                    : selectedInsertImages.includes(el?.id)
                                      ? true
                                      : isAllInsertImages
                                }
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                              <p className="imgTitle">{el?.filename}</p>
                              <Tooltip>
                                <img
                                  src={el?.base64data}
                                  alt="images"
                                  style={{
                                    marginTop: 30,
                                    opacity:
                                      selectedInsertImages.length > 0
                                        ? selectedInsertImages.includes(el?.id)
                                          ? "1"
                                          : "0.5"
                                        : "1",
                                  }}
                                />
                              </Tooltip>
                              <div className="uploadedDateInfo">
                                <strong>Uploaded on</strong>{" "}
                                {verboseDateToString(
                                  el?.uploadedUtc,
                                  "DD/MMM/YY"
                                )}{" "}
                                || {el?.size}
                              </div>
                              <div className="overlay">
                                <StyledCheckbox className="checkbox"></StyledCheckbox>
                                <div className="edit-wrapper">
                                {(el?.shared && (isUserAdmin(getUserRole && getUserRole?.Role)||isUserSupport(getUserRole && getUserRole?.Role))) || (!el?.shared && !(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role))) ? <Tooltip title={t("Edit_description")}>
                                    <button
                                      name={el?.id}
                                      onClick={() =>
                                        renderEditImageDesc(
                                          el?.description,
                                          el?.filename,
                                          el?.base64data,
                                          el?.id
                                        )
                                      }
                                    >
                                      <EditIcon
                                        color="#fff"
                                        width={9.34}
                                        height={9.34}
                                      />
                                    </button>
                                  </Tooltip>:<></>}
                                  <Tooltip title={t("View_full_size")}>
                                    <button
                                      id={el?.id}
                                      onClick={(e) =>
                                        checkModal(e, insertClonedArray)
                                      }
                                      className="zoom-icon"
                                    >
                                      <ZoomIcon
                                        color="#fff"
                                        width={9.34}
                                        height={9.34}
                                        pointerEvents="none"
                                      />
                                    </button>
                                  </Tooltip>
                                </div>
                              </div>
                              <div className="imageSubtitle">{imageSubtitle(el)}</div>
                            </div>
                          );
                        })}
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}

            {insertImages && sharedImages && localImages ? (
              <>
                <div className="insert-image-wrapper">
                  <div className="head">
                    <h6>{t("Insert")}</h6>
                    {sortAndFilter(dropDownValue, insertClonedArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, insertClonedArray).find(
                        (item) => {
                          return !item?.fullPage;
                        }
                      ) ? (
                      <StyledCheckbox className="checkbox">
                        <Tooltip title={t("Select_all")} className="title">
                          <FormControlLabel
                            label={t("Select_all")}
                            control={
                              <Checkbox
                                checked={isAllInsertImages}
                                onClick={(e) => selectItem(e, "insertImage")}
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                            }
                          />
                        </Tooltip>
                      </StyledCheckbox>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="image-main-wrapper">
                    {sortAndFilter(dropDownValue, insertClonedArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, insertClonedArray)
                        .filter((item) => {
                          return !item?.fullPage;
                        })
                        .map((el) => {
                          return (
                            <div className="image-wrapper">
                              <Checkbox
                                className="custom-position"
                                sx={overlayStyle}
                                key={el?.id}
                                onClick={() =>
                                  handleCheckboxClick(
                                    el.id,
                                    "insertImage",
                                    setSelectedInsertImages
                                  )
                                }
                                checkedList={checkedList}
                                checked={
                                  selectedInsertImages.includes(el?.id) &&
                                    isAllInsertImages
                                    ? true
                                    : selectedInsertImages.includes(el?.id)
                                      ? true
                                      : isAllInsertImages
                                }
                                icon={<UnCheckIcon width={20} height={20} />}
                                checkedIcon={
                                  <CheckIcon width={20} height={20} />
                                }
                              />
                              <p className="imgTitle">{el?.filename}</p>
                              <Tooltip>
                                <img
                                  src={el?.base64data}
                                  alt="images"
                                  style={{
                                    marginTop: 30,
                                    opacity:
                                      selectedInsertImages.length > 0
                                        ? selectedInsertImages.includes(el?.id)
                                          ? "1"
                                          : "0.5"
                                        : "1",
                                  }}
                                />
                              </Tooltip>
                              <div className="uploadedDateInfo">
                                <strong>Uploaded on</strong>{" "}
                                {verboseDateToString(
                                  el?.uploadedUtc,
                                  "DD/MMM/YY"
                                )}{" "}
                                || {el?.size}
                              </div>
                              <div className="overlay">
                                <StyledCheckbox className="checkbox"></StyledCheckbox>
                                <div className="edit-wrapper">
                                {(el?.shared && (isUserAdmin(getUserRole && getUserRole?.Role) ||isUserSupport(getUserRole && getUserRole?.Role))) || (!el?.shared && !(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role))) ? <Tooltip title={t("Edit_description")}>
                                    <button
                                      name={el?.id}
                                      onClick={() =>
                                        renderEditImageDesc(
                                          el?.description,
                                          el?.filename,
                                          el?.base64data,
                                          el?.id
                                        )
                                      }
                                    >
                                      <EditIcon
                                        color="#fff"
                                        width={9.34}
                                        height={9.34}
                                      />
                                    </button>
                                  </Tooltip>:<></>}
                                  <Tooltip title={t("View_full_size")}>
                                    <button
                                      id={el?.id}
                                      onClick={(e) =>
                                        checkModal(e, insertClonedArray)
                                      }
                                      className="zoom-icon"
                                    >
                                      <ZoomIcon
                                        color="#fff"
                                        width={9.34}
                                        height={9.34}
                                        pointerEvents="none"
                                      />
                                    </button>
                                  </Tooltip>
                                </div>
                              </div>
                              <div className="imageSubtitle">{imageSubtitle(el)}</div>
                            </div>
                          );
                        })}
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </MainSection>
        </BodySection>
      ) : (
        <CenteredLoader>
          <Loader />
        </CenteredLoader>
      )}
    </Container>
  );
};

export default ImageGallery;
